import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageService } from '../core/i18n/language.service';
import { SupportedLanguage } from '../core/i18n/language.constants';

@Component({
  selector: 'gg-language-selector',
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *transloco="let t" style="position:relative">
      <button
        type="button"
        [attr.aria-label]="t('language.selectorLabel')"
        [attr.aria-expanded]="open()"
        style="height:36px;min-width:54px;border:1px solid #e2dccf;background:#fff;border-radius:999px;padding:0 12px;display:flex;align-items:center;justify-content:center;gap:6px;font-size:12.5px;font-weight:800;color:#16213c;cursor:pointer"
        (click)="toggle()"
      >
        <span>{{ t('language.activeCode') }}</span>
        <span style="font-size:10px;color:#8a93a3;line-height:1">▾</span>
      </button>

      @if (open()) {
        <div
          style="position:absolute;right:0;top:44px;z-index:80;background:#fff;border:1px solid #e7ddc9;border-radius:14px;box-shadow:0 18px 44px -22px rgba(28,36,52,.42);padding:6px;min-width:138px"
        >
          @for (lang of language.languages; track lang) {
            <button
              type="button"
              style="width:100%;border:0;background:transparent;border-radius:10px;padding:9px 10px;display:flex;align-items:center;justify-content:space-between;gap:12px;cursor:pointer;font-size:13px;font-weight:700;color:#16213c;text-align:left"
              [style.background]="language.activeLang() === lang ? '#faf6ec' : 'transparent'"
              (click)="select(lang)"
            >
              <span>{{ t('language.names.' + lang) }}</span>
              <span style="font-family:var(--font-mono);font-size:11px;color:#a8895a">{{ lang.toUpperCase() }}</span>
            </button>
          }
        </div>
      }
    </div>
  `,
})
export class LanguageSelectorComponent {
  readonly language = inject(LanguageService);
  readonly open = signal(false);

  toggle(): void {
    this.open.update((value) => !value);
  }

  select(lang: SupportedLanguage): void {
    this.language.setLanguage(lang);
    this.open.set(false);
  }
}
